module.exports = __webpack_public_path__ + "static/jessica-ruscello-196422-unsplash-58373dcbd401256cafc057c620e76e9c.jpg";